import Cookies from 'js-cookie'
import storage from 'good-storage'

/**
 * 设置 cookie
 * @param key 键
 * @param value 值
 * @param options 选项
 * @returns 值
 * @example saveCookie('key', 'value')
 * @example saveCookie('key', 'value', { expires: 1 })
 */
export function saveCookie(key: string, value: string, options?: Cookies.CookieAttributes) {
  Cookies.set(key, value, options)
  return value
}

/**
 * 获取 cookie
 * @param key 键
 * @returns 值
 * @example loadCookie('key')
 */
export function loadCookie(key: string, defaultValue: string) {
  return Cookies.get(key) || defaultValue
}

/**
 * 删除cookie
 * @param key
 * @example removeCookie('key')
 */
export function removeCookie(key: string): void {
  Cookies.remove(key)
}

/**
 * 设置本地存储
 * @param key
 * @param value
 * @example saveStorage('key', 'value')
 */
export function saveStorage<T>(key: string, value?: T): T | undefined {
  storage.set(key, value)
  return value
}

/**
 * 获取本地存储
 * @param key
 * @param defaultValue
 * @example loadStorage('key')
 */
export function loadStorage<T>(key: string, defaultValue?: T): T {
  return storage.get(key, defaultValue)
}

/**
 * 删除本地存储
 * @param key
 * @example removeStorage('key')
 */
export function removeStorage(key: string): void {
  storage.remove(key)
}

/**
 * 保存会话存储
 * @param key
 * @param value
 * @example saveSessionStorage('key', 'value')
 */
export function saveSessionStorage<T>(key: string, value?: T): T | undefined {
  storage.session.set(key, value)
  return value
}

/**
 * 获取会话存储
 * @param key
 * @param defaultValue
 * @example loadSessionStorage('key')
 * @example loadSessionStorage('key', 'value')
 */
export function loadSessionStorage<T>(
  key: string,
  defaultValue?: T,
): T | undefined {
  return storage.session.get(key, defaultValue)
}

/**
 * 删除会话存储
 * @param key
 * @example removeSessionStorage('key')
 */
export function removeSessionStorage(key: string): void {
  storage.session.remove(key)
}
